// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1jnvl","footer":"ModalError_footer__1_yNJ"};